import { createContext } from "react";

const SettingContext = createContext(null);

export default SettingContext;
